import { Icon, PathButton } from "shared/react";
import { ProfilePhoto } from "../entity/EntityPhoto.js";
import { NotificationDot } from "../notification/NotificationDot.js";
import { useItem } from "../util/db.js";
import { USER } from "../util/user.js";

export function Navigation(): React.ReactElement {
	const uid = USER.data.uid;
	const { noticeDate } = useItem("user", uid).data;
	return (
		<nav className="nav">
			<div className="width-wide flex-row flex-stretch">
				<PathButton mods="button-quiet" title="Challenges" path="/challenges">
					<Icon icon="challenge" />
				</PathButton>
				<PathButton mods="button-quiet" title="Posts" path="/posts">
					<Icon icon="post" />
				</PathButton>
				<PathButton mods="button-quiet" title="Groups" path="/groups">
					<Icon icon="chat" />
				</PathButton>
				<PathButton mods="button-quiet" title="Notifications" path="/notifications">
					<Icon icon="notification" />
					<NotificationDot uid={uid} since={noticeDate} mods="pin-top pin-right" />
				</PathButton>
				<PathButton mods="button-quiet" title="Profile" path="/me">
					<ProfilePhoto uid={uid} mods="size-xlarge" />
				</PathButton>
				<PathButton mods="button-quiet" title="Menu" path="/menu">
					<Icon icon="menu" />
				</PathButton>
			</div>
		</nav>
	);
}
